import React from 'react';

const PhoneIcon = ({showNewUI = false, fillColor = '#3c25d8', size = '40'}) =>
  showNewUI ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 19 18"
      fill="none">
      <path
        stroke={fillColor}
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="M17.975 14.275c0 .3-.067.608-.208.908a3.44 3.44 0 0 1-.567.85c-.408.45-.858.775-1.367.984-.5.208-1.041.316-1.625.316-.85 0-1.758-.2-2.716-.608a14.642 14.642 0 0 1-2.867-1.65 23.952 23.952 0 0 1-2.733-2.333 23.671 23.671 0 0 1-2.325-2.725c-.684-.95-1.234-1.9-1.634-2.842-.4-.95-.6-1.858-.6-2.725 0-.567.1-1.108.3-1.608.2-.509.517-.975.959-1.392C3.125.925 3.708.667 4.325.667c.233 0 .467.05.675.15.217.1.408.25.558.466l1.934 2.725c.15.209.258.4.333.584.075.175.117.35.117.508 0 .2-.059.4-.175.592a2.835 2.835 0 0 1-.467.591l-.633.659a.446.446 0 0 0-.134.333c0 .067.009.125.025.192.025.066.05.116.067.166.15.275.408.634.775 1.067.375.433.775.875 1.208 1.317.45.441.884.85 1.325 1.225.434.366.792.616 1.075.766.042.017.092.042.15.067a.576.576 0 0 0 .209.033c.141 0 .25-.05.341-.141l.634-.625c.208-.209.408-.367.6-.467a1.11 1.11 0 0 1 .591-.175c.159 0 .325.033.509.108.183.075.375.184.583.325l2.758 1.959c.217.15.367.325.459.533.083.208.133.417.133.65Z"
      />
    </svg>
  ) : (
    <svg
      id="Phone"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 72">
      <circle
        id="Ellipse_707"
        data-name="Ellipse 707"
        cx="36"
        cy="36"
        r="36"
        fill="rgba(41,97,250,0)"
      />
      <path
        id="Path_65856"
        data-name="Path 65856"
        d="M21.6,2.263a1.087,1.087,0,0,1,1.332-.749A15.418,15.418,0,0,1,33.92,12.307a1.051,1.051,0,0,1-.165,1.165,1.1,1.1,0,0,1-1.156.307,1.069,1.069,0,0,1-.739-.925h0a13.268,13.268,0,0,0-9.489-9.281A1.071,1.071,0,0,1,21.6,2.263Zm-.728,6.792a7.488,7.488,0,0,1,5.363,5.268,1.094,1.094,0,0,0,1.332.755,1.076,1.076,0,0,0,.657-.5,1.043,1.043,0,0,0,.106-.807,9.666,9.666,0,0,0-6.866-6.745,1.1,1.1,0,0,0-1.183.162,1.054,1.054,0,0,0-.315,1.132,1.081,1.081,0,0,0,.935.73Zm14.42,17.4a9.706,9.706,0,0,1-9.647,8.371A25.45,25.45,0,0,1,0,9.636,9.652,9.652,0,0,1,8.521.132a2.548,2.548,0,0,1,2.63,1.491l3.626,8.317a2.418,2.418,0,0,1-.206,2.334l-3.008,4.513a.345.345,0,0,0,0,.337h0a14.059,14.059,0,0,0,6.551,6.4.349.349,0,0,0,.343,0l4.518-2.968a2.566,2.566,0,0,1,2.4-.216l8.46,3.561a2.476,2.476,0,0,1,1.517,2.583ZM33.145,26.2a.363.363,0,0,0-.22-.364L24.493,22.3a.363.363,0,0,0-.343,0l-4.518,2.968a2.573,2.573,0,0,1-2.486.182,16.214,16.214,0,0,1-7.553-7.42,2.438,2.438,0,0,1,.165-2.435l3.008-4.506a.365.365,0,0,0,0-.337l-3.6-8.29a.364.364,0,0,0-.33-.216H8.789A7.5,7.5,0,0,0,2.17,9.663,23.3,23.3,0,0,0,25.646,32.731,7.556,7.556,0,0,0,33.172,26.2Z"
        transform="translate(18.055 17.244)"
        fill={fillColor}
      />
    </svg>
  );

export default PhoneIcon;
